// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__16aXF","textField":"Search_textField__1c2Hz","fieldset":"Search_fieldset__OeFSr","input":"Search_input__3iTQH","icon":"Search_icon__2He--"};